import type { FunctionComponent } from 'react';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useAuth } from 'react-oidc-context';

import { MethodType } from '@endeavour/payment-integration';

import { BlockType, useCompliancePrompt } from '../../../sessions/hooks/use-compliance-prompt';
import { Loader } from '../../../shared/components/loader/loader';
import { usePromiseValue } from '../../../shared/hooks/use-promise-value';
import { Cashier } from '../../components/cashier/cashier';
import { SelectMethod } from '../../components/select-transaction-type/select-method';
import { useGetPaymentMethod } from '../../hooks/use-get-payment-method';
import { usePaymentProviders } from '../../hooks/use-payment-providers';
import { useProviderIntegration } from '../../util/provider-context';

export const WithdrawalPage: FunctionComponent = () => {
    const intl = useIntl();
    const provider = useProviderIntegration();
    const { paymentList } = usePaymentProviders({
        type: MethodType.WITHDRAWAL,
    });
    const auth = useAuth();
    const userProfileId = auth?.user?.profile?.user_profile_id as string;

    const providerList = useGetPaymentMethod(MethodType.WITHDRAWAL, paymentList).methodDetails;

    const savedMethods = usePromiseValue(
        useMemo(() => {
            if (
                !userProfileId ||
                providerList.resolving ||
                !providerList.data ||
                !providerList.data.length
            ) {
                return Promise.resolve([]);
            }

            return provider.getSavedAccounts({
                configuration: {
                    userProfileId,
                },
                type: MethodType.WITHDRAWAL,
                methods: providerList.data,
            });
        }, [userProfileId, provider, providerList]),
    );

    const title = intl.formatMessage({
        id: 'cashier.withdrawal.select-method.title',
        defaultMessage: 'Select withdrawal method',
    });

    const { prompt } = useCompliancePrompt(BlockType.WITHDRAWAL);
    console.log(providerList, 'PROVIDERS LIST DATA THAT TRIGGER THE LOADER');

    if (providerList.resolving || !providerList.data || !providerList.data.length) {
        console.log(providerList, 'LOADER HAS BEEN TRIGGERED');
        return <Loader />;
    }

    return (
        <Cashier title={title}>
            {prompt}
            <SelectMethod paymentMethods={paymentList} savedMethods={savedMethods.data} />
        </Cashier>
    );
};
